/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of transaction. payment(one time payments) and invoice(subscription)
 */
export const TransactionType = {
  Payment: "payment",
  Invoice: "invoice",
} as const;
/**
 * The type of transaction. payment(one time payments) and invoice(subscription)
 */
export type TransactionType = ClosedEnum<typeof TransactionType>;

/** @internal */
export const TransactionType$inboundSchema: z.ZodNativeEnum<
  typeof TransactionType
> = z.nativeEnum(TransactionType);
/** @internal */
export const TransactionType$outboundSchema: z.ZodNativeEnum<
  typeof TransactionType
> = TransactionType$inboundSchema;
